module.exports = __webpack_public_path__ + "static/media/Screenshotpage6.5c666a7b.png";